export default "__VITE_PUBLIC_ASSET__5b2db7c4__"